import React from 'react'

const OilPressure = ({ width = '50px', height = '20px', color }) => (
  <svg viewBox="0 0 50 20" version="1.1" width={width} height={height}>
    <title>Icon/Dashboard/ABS Copy 6@3x</title>
    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="Interior_Lights_D" transform="translate(-372.000000, -757.000000)" stroke={color} strokeWidth="1.01398638">
        <g id="Group" transform="translate(365.000000, 735.000000)">
          <g id="ICOPath-OilPressure" transform="translate(8.000000, 23.200000)">
            <line x1="12.8" y1="0.050699319" x2="21.6" y2="0.050699319" id="Path"></line>
            <line x1="17.6506993" y1="4.8" x2="17.6506993" y2="0" id="Path"></line>
            <path
              d="M13.0821861,5.83559432 L22.5398785,5.83559432 L22.5398785,7.83554225 C22.5398785,7.83554225 26.8073888,7.83554225 28.4220647,7.83554225 C30.0367406,7.83554225 33.9582997,5.60031243 36.3803644,4.07092829 C38.802429,2.54154414 42.1472673,2.89451883 44.8,6.18856901 L41.8012145,9.48261919 C41.8012145,9.48261919 39.1484818,6.07097991 36.4957492,8.89436261 C33.8430165,11.7177453 27.9608304,17.6 27.9608304,17.6 L8.46872475,17.6 C8.46872475,17.6 7.2,17.6 7.2,15.1294883 C7.2,12.6589766 7.2,9.83549018 7.2,9.83549018 L13.0821861,5.83559432 Z"
              id="Path"></path>
            <path d="M10.4,7.13244661 C10.4,7.13244661 5.60110714,-2.88862106 1.12381485,2.28170344 C-2.74339696,6.74759133 4.33301629,10.2106623 7.82169202,9.50946325" id="Path"></path>
            <path
              d="M46,16 C44.8972202,16 44,15.0762702 44,13.9409072 C44,13.3147732 44.2675146,12.1267132 44.7790543,11.0673861 C45.2951072,9.99844892 45.8019284,9.6 46,9.6 C46.1980716,9.6 46.7048928,9.99834332 47.2209457,11.0673861 C47.7323828,12.1267132 48,13.3147732 48,13.9409072 C48,15.0761645 47.1027798,16 46,16 Z"
              id="Path"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export default OilPressure
